import I18n from '~/utils/i18n';
import sortBy from 'lodash/sortBy';
import { CALIBRATION_STATUSES } from '~/utils/constants';
import type { ICalibrationModel } from '../model';

// Single-parameter status: a measurement is Completed/Failed based on its own result.
// `timestamp` is the applied time and is set on every attempt record.
export function getStatus(calibration) {
  const { calibrated, timestamp } = calibration;
  if (timestamp) {
    return calibrated ? CALIBRATION_STATUSES.COMPLETED : CALIBRATION_STATUSES.FAILED;
  }
  return CALIBRATION_STATUSES.NOT_RUN;
}

// Device-level status: Failed only when a parameter actually failed calibration.
// A never-attempted channel (e.g. factory-calibrated CO₂) is not a failure.
export function getDeviceStatus(calibration) {
  const params = calibration.measurements ?? [];
  if (!calibration.timestamp || params.length === 0) {
    return CALIBRATION_STATUSES.NOT_RUN;
  }
  if (params.some((param) => param.calibrated === false)) {
    return CALIBRATION_STATUSES.FAILED;
  }
  return CALIBRATION_STATUSES.COMPLETED;
}

export default (self: ICalibrationModel) => {
  return {
    get status() {
      return getDeviceStatus(self);
    },
    get statusType() {
      return self.status;
    },
    get statusText() {
      return I18n.t(`attributes.calibration.statuses.${self.status}`);
    },
    get parameters() {
      return sortBy(self.measurements, 'name');
    },
    get valueLabelPair() {
      return { label: self.serial, value: self.serial, model: self };
    }
  };
};
